import React, {useEffect, useState} from "react";
import ActsService from "../../services/acts.service";
import {useParams} from "react-router-dom";
import ActItem from "./actItem.component";
import ActEdit from "./actEdit.component";
import {Breadcrumb, Col, Row} from "react-bootstrap";
import Container from "react-bootstrap/Container";

const ActDetail = () => {
    let path = window.location.pathname
    let {actId} = useParams();
    const [act, setAct] = useState()

    const fetchAct = (actId) => {
        if (actId !== undefined) {
            ActsService.getActById(actId).then(
                response => {
                    setAct(response.data);
                    console.log("act:" + JSON.stringify(response.data));
                },
                error => {
                    console.log(error);
                });
        } else {
            let newAct = {}
            newAct.name = "";
            newAct.bio = "";
            newAct.type = "americana";
            newAct.rain_date_available = true;
            newAct.preferred_slots = []
            setAct(newAct);
        }
    }

    // load once on mount to fetch act
    useEffect(() => {
        fetchAct(actId);
    }, [actId]);

    // console.log("act:" + JSON.stringify(act));
    // console.log("actId:" + actId);
    // console.log("path:" + path);

    if (act !== undefined) {
        return (
            <Container fluid>
                <Row>
                    <Col>
                        <h3>
                            <Breadcrumb>
                                <Breadcrumb.Item active>Acts</Breadcrumb.Item>
                                {path.includes("new") &&
                                    <Breadcrumb.Item active>New Act</Breadcrumb.Item>
                                }
                                {!path.includes("new") &&
                                    <Breadcrumb.Item active>{act.name}</Breadcrumb.Item>
                                }
                            </Breadcrumb>
                        </h3>

                        {(!path.includes("edit") && !path.includes("new")) &&
                            <>
                                <ActItem act={act}/>
                            </>
                        }
                        {(path.includes("edit") || path.includes("new")) &&
                            <ActEdit act={act}/>
                        }
                    </Col>
                </Row>
            </Container>
        )
    }
};

export default ActDetail;
